import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { SabiasQueNY, estiloH3NY, estiloPNY } from "./nyHelpers";

// Template78: Día 3 DUMBO Brooklyn 2 (Page4) - Empire/Time Out, St. Ann's, Brooklyn Bridge Park, Puente. Contenido desde page.
const Template78 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItems = (html) => {
		if (!html) return [];
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const ps = doc.querySelectorAll("p");
		const items = [];
		ps.forEach((p) => {
			const text = (p.textContent ?? p.innerText ?? "").trim();
			if (!text) return;
			const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
			if (emojiMatch)
				items.push({ icono: emojiMatch[1], texto: emojiMatch[2].trim() });
		});
		return items;
	};

	const title = page?.texts?.[0]?.content;
	const empireTitle = page?.texts?.[1]?.content;
	const empireBody = page?.texts?.[2]?.content;
	const stannsTitle = page?.texts?.[3]?.content;
	const stannsBody = page?.texts?.[4]?.content;
	const yellowJuliana = page?.texts?.[5]?.content;
	const parkTitle = page?.texts?.[6]?.content;
	const parkBody = page?.texts?.[7]?.content;
	const sabiasQueItems = parseSabiasQueItems(page?.texts?.[8]?.content);
	const dumboInfo = page?.texts?.[9]?.content;
	const puenteTitle = page?.texts?.[10]?.content;
	const puenteBody = page?.texts?.[11]?.content;

	const timeoutSrc = getImageSrc("timeout");
	const stannsSrc = getImageSrc("stanns");
	const brooklynBridgeSrc = getImageSrc("brooklyn-bridge");
	const puenteBrooklynSrc = getImageSrc("puente-brooklyn");
	const puenteSrc = getImageSrc("puente");
	const pizzaSrc = getImageSrc("pizza");
	const pizza2Src = getImageSrc("pizza-2");
	const logoSrc = getCanvasImageUrl("logo");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": { marginTop: "0px !important", marginBottom: "0px !important" },
				"& a": {
					color: "#007a8d",
					fontWeight: 700,
					textDecoration: "underline",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{title}
				{logoSrc && (
					<img
						src={logoSrc}
						alt="logo"
						style={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</div>

			<div style={{ padding: "10px 12px 0px", flex: 1 }}>
				<div
					style={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: 16,
						position: "relative",
						paddingBottom: isSmallScreen ? 0 : 0,
					}}
				>
					{/* Empire / Time Out */}
					{(empireTitle || empireBody || timeoutSrc) && (
						<div data-block-id="text-1" style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
							{timeoutSrc && (
								<img
									src={timeoutSrc}
									alt="Time Out"
									style={{
										width: "40%",
										height: 110,
										borderRadius: 12,
										objectFit: "cover",
									}}
								/>
							)}
							<div style={{ width: "60%" }}>
								{empireTitle && (
									<h3 style={{ ...estiloH3NY, marginBottom: 4, marginTop: 8 }}>
										{empireTitle}
									</h3>
								)}
								{empireBody && (
									<p
										style={{
											fontSize: 13,
											color: "#444",
											fontFamily: '"Poppins", sans-serif',
											margin: 0,
										}}
									>
										{empireBody}
									</p>
								)}
							</div>
						</div>
					)}

					{/* St. Ann's */}
					{(stannsTitle || stannsBody || stannsSrc) && (
						<div
							data-block-id="text-2"
							style={{
								display: "flex",
								gap: 20,
								alignItems: "flex-start",
								position: "relative",
							}}
						>
							{(isSmallScreen ? pizza2Src : pizzaSrc) && (
								<img
									src={isSmallScreen ? pizza2Src : pizzaSrc}
									alt="pizza"
									style={{
										width: 95,
										position: "absolute",
										top: isSmallScreen ? -60 : undefined,
										bottom: isSmallScreen ? undefined : -52,
										left: isSmallScreen ? -30 : "auto",
										right: isSmallScreen ? "auto" : 0,
										zIndex: 3,
									}}
								/>
							)}
							{yellowJuliana && (
								<div
									style={{
										position: "absolute",
										bottom: isSmallScreen ? 150 : -35,
										left: isSmallScreen ? 20 : "auto",
										right: isSmallScreen ? "auto" : 75,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: isSmallScreen
											? "16px 16px 16px 0px"
											: "16px 16px 0px 16px",
										padding: "10px 12px",
										fontSize: 11,
										fontFamily: '"Poppins", sans-serif',
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 100 : 160,
										zIndex: 3,
									}}
								>
									{yellowJuliana.includes(",") ? (
										<>
											<strong>{yellowJuliana.split(",")[0]}, </strong>
											<br />
											{yellowJuliana.split(",").slice(1).join(",").trim()}
										</>
									) : (
										yellowJuliana
									)}
								</div>
							)}
							{stannsSrc && (
								<img
									src={stannsSrc}
									alt="St. Ann's"
									style={{
										width: "40%",
										height: 110,
										borderRadius: 12,
										objectFit: "cover",
									}}
								/>
							)}
							<div style={{ width: "60%", position: "relative" }}>
								{stannsTitle && (
									<h3 style={{ ...estiloH3NY, marginBottom: 4, marginTop: 8 }}>
										{stannsTitle}
									</h3>
								)}
								{stannsBody && (
									<p
										style={{
											fontSize: 13,
											color: "#444",
											fontFamily: '"Poppins", sans-serif',
											margin: 0,
										}}
									>
										{stannsBody}
									</p>
								)}
							</div>
						</div>
					)}

					{/* Brooklyn Bridge Park */}
					{(parkTitle || parkBody || brooklynBridgeSrc) && (
						<div
							data-block-id="text-3"
							style={{
								display: "flex",
								gap: 20,
								alignItems: "flex-start",
								position: "relative",
							}}
						>
							{brooklynBridgeSrc && (
								<img
									src={brooklynBridgeSrc}
									alt="Brooklyn Bridge Park"
									style={{
										width: "40%",
										height: 110,
										borderRadius: 12,
										objectFit: "cover",
									}}
								/>
							)}
							<div style={{ width: "60%", position: "relative" }}>
								{sabiasQueItems[0] && (
									<div style={{ position: "relative", top: 0, right: -50 }}>
										<SabiasQueNY
											icono={sabiasQueItems[0].icono}
											texto={sabiasQueItems[0].texto}
										/>
									</div>
								)}
								{sabiasQueItems[1] && (
									<div style={{ position: "absolute", top: 0, left: 0 }}>
										<SabiasQueNY
											icono={sabiasQueItems[1].icono}
											texto={sabiasQueItems[1].texto}
										/>
									</div>
								)}
								{parkTitle && (
									<h3 style={{ ...estiloH3NY, marginBottom: 4, marginTop: 8 }}>
										{parkTitle}
									</h3>
								)}
								{parkBody && (
									<p
										style={{
											fontSize: 13,
											color: "#444",
											fontFamily: '"Poppins", sans-serif',
											margin: 0,
										}}
									>
										{parkBody}
									</p>
								)}
							</div>
						</div>
					)}

					{dumboInfo && (
						<div
							data-block-id="text-4"
							style={{
								backgroundColor: "#e0f7fa",
								border: "2px solid #59c3d8",
								borderRadius: "12px",
								padding: "8px 14px",
								fontSize: "12px",
								color: "#444",
								textAlign: "center",
								fontFamily: '"Poppins", sans-serif',
							}}
						>
							{dumboInfo}
						</div>
					)}

					{/* Puente de Brooklyn */}
					{(puenteTitle || puenteBody || puenteBrooklynSrc) && (
						<div data-block-id="text-5" style={{ position: "relative" }}>
							<div style={{ padding: "10px 12px", position: "relative" }}>
								{sabiasQueItems[2] && (
									<div
										style={{
											position: "absolute",
											top: isSmallScreen ? -10 : 0,
											left: "50%",
										}}
									>
										<SabiasQueNY
											icono={sabiasQueItems[2].icono}
											texto={sabiasQueItems[2].texto}
										/>
									</div>
								)}
								{puenteTitle && (
									<h3
										style={{
											fontFamily: '"Poppins", sans-serif',
											fontSize: 14,
											fontWeight: 700,
											textTransform: "uppercase",
											margin: 0,
										}}
									>
										{puenteTitle}
									</h3>
								)}
								{puenteBody && (
									<p
										style={{
											fontSize: 13,
											color: "#444",
											fontFamily: '"Poppins", sans-serif',
											margin: 0,
										}}
									>
										{puenteBody}
									</p>
								)}
							</div>
							{puenteSrc && (
								<img
									src={puenteSrc}
									alt="puente"
									style={{
										width: 150,
										position: "absolute",
										bottom: 0,
										right: 0,
									}}
								/>
							)}
							{puenteBrooklynSrc && (
								<img
									src={puenteBrooklynSrc}
									alt="Brooklyn Bridge"
									style={{
										width: "calc(100% + 40px)",
										marginLeft: "-20px",
										height: 120,
										objectFit: "cover",
									}}
								/>
							)}
						</div>
					)}
				</div>
			</div>
		</Box>
	);
};

export default Template78;
